<template>
  <DsShowcase title="InputDateTimePlay" description="Input de data e hora com seletor nativo do browser.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: string</code></p>
      <div class="tw:max-w-lg tw:space-y-3">
        <InputDateTimePlay v-model="dt1" label="Data e hora" />
        <p class="tw:text-xs tw:opacity-50">Valor: {{ dt1 || '—' }}</p>
      </div>
    </section>

    <!-- Tipo date only -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">type</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'datetime-local' | 'date' | 'time'</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <InputDateTimePlay v-model="dt2" label="Somente data" type="date" />
        <InputDateTimePlay v-model="dt3" label="Somente hora" type="time" />
        <InputDateTimePlay v-model="dt4" label="Data e hora" type="datetime-local" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { InputDateTimePlay } from '@/components/atomic'

const dt1 = ref('')
const dt2 = ref('')
const dt3 = ref('')
const dt4 = ref('')
</script>
